import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import useHashScroll from "@/hooks/useHashScroll";
import HeroSection from "@/pages/home/components/HeroSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LatestSection from "@/pages/home/components/LatestSection";
import HotAndTopicsSection from "@/pages/home/components/HotAndTopicsSection";
import MethodologySection from "@/pages/home/components/MethodologySection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import FaqPreviewSection from "@/pages/home/components/FaqPreviewSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

export default function Home() {
  useHashScroll();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Seo
        title="15黑料网 - 事件深度解读·内幕解析与真相挖掘复盘"
        description="15黑料网专注热点事件深度解读与内幕解析，从事件复盘到真相挖掘，每篇梳理时间线、关键人物与疑点，帮助你理解事件的完整经过与深层逻辑。"
        keywords="15黑料网,事件分析,深度解读,内幕解析,真相挖掘"
        canonicalPath="/"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "15黑料网",
            url: "https://sznita.cn/",
            description:
              "专注热点事件深度解读、内幕解析与真相挖掘复盘的内容平台，用时间线与疑点清单还原事件逻辑。",
            email: "editor@15heiliao.com",
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "15黑料网",
            url: "https://sznita.cn/",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://sznita.cn/analysis?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "15黑料网 - 事件深度解读·内幕解析与真相挖掘复盘",
            url: "https://sznita.cn/",
            inLanguage: "zh-CN",
          },
        ]}
      />
      <SiteHeader logoAsHeading />
      <main className="w-full flex-1">
        <HeroSection />
        <FeaturedSection />
        <LatestSection />
        <HotAndTopicsSection />
        <MethodologySection />
        <TestimonialsSection />
        <FaqPreviewSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}